import useConnectWallet from "@/store/wallet/useConnectWallet"
import { useCallback, useState } from "react"
import { toast } from "react-toastify"

const useFlowDeposit = () => {
    // loading
    const [flowDepositLod, setLoading] = useState(false)
    // 获取合约
    const { contractEvm: { FlexibleStaking } } = useConnectWallet()

    // 质押方法
    const flowDeposit = useCallback(async (amount: bigint,
        toastText: { success: string, error: string },
        successFn?: Function, errorFn?: Function
    ) => {
        try {
            setLoading(true)
            if (FlexibleStaking) {
                const tx = await FlexibleStaking.deposit(amount)
                await tx.wait()
                toast.success(toastText.success)
                successFn && successFn();
            }
        } catch (e) {
            console.log('useFlowDeposit', e);
            toast.error(toastText.error)
            errorFn && errorFn();
        } finally {
            setLoading(false)
        }
    }, [FlexibleStaking])
    return { flowDepositLod, flowDeposit }
}

export default useFlowDeposit